(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[381],{

/***/ "fhU6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CharmPrestige", function() { return CharmPrestige; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var CharmPrestige = function CharmPrestige(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 281.1"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M495.2 169.2l-100-70v-79c0-6.2-5.1-11.3-11.3-11.3h-36.3c-6.2 0-11.3 5.1-11.3 11.3V58L256.5 2c-3.9-2.7-9.1-2.7-13 0L4.8 169.2c-5.1 3.6-6.3 10.6-2.8 15.7 2.2 3.1 5.7 4.8 9.3 4.8 2.2 0 4.5-.7 6.5-2L250 25.1l232.2 162.7c5.1 3.6 12.1 2.3 15.7-2.8 3.6-5.1 2.4-12.2-2.7-15.8zM358.9 31.5h13.7v51.8l-13.7-9.6V31.5z"
  }), __jsx("path", {
    d: "M359.9 206.9c6.2 0 11.3-5.1 11.3-11.3v-55c0-3.7-1.8-7.1-4.8-9.2l-109.9-77c-3.9-2.7-9.1-2.7-13 0l-109.9 77c-3 2.1-4.8 5.6-4.8 9.2v55c0 6.2 5.1 11.3 11.3 11.3h219.8zm-208.5-55h32.4v32.4h-32.4v-32.4zm142.2 0v32.4h-32.4v-32.4h32.4zm-54.9 32.4h-32.4v-32.4h32.4v32.4zm77.5 0v-32.4h32.4v32.4h-32.4zM250 77.4l74.1 52H175.9l74.1-52z"
  }), __jsx("path", {
    d: "M431.6 168.7c-6.2 0-11.3 5.1-11.3 11.3v78.6H79.7V179c0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3v90.9c0 6.2 5.1 11.3 11.3 11.3h363.2c6.2 0 11.3-5.1 11.3-11.3V180c0-6.3-5.1-11.3-11.3-11.3z"
  }));
};

/***/ })

}]);